import {
    SET_UNIT_VALUE_SELECTION,
    SET_PUMP_FAMILIES_PENDING,
    SET_PUMP_FAMILIES,
    GET_SEARCHDATA_PENDING,
    SET_SEARCHDATA,
    GET_SEARCHDATA_SUCCESS,
    GET_SEARCHDATA_ERROR,
    SET_PUMP_DATA_LIST_PAGER,
    OPEN_PRINT_SELECTION_MODEL,
    CLOSE_PRINT_SELECTION_MODEL,
    SET_QEFF_GRAPH_PENDING,
    SET_QEFF_GRAPH,
    SET_SHAFT_GRAPH_PENDING,
    SET_FILTER_VALUES,
    SET_PUMP_FAMILY,
    SET_SHAFT_GRAPH,
    SET_SELECTION_CRITERIA,
    SET_PUMPREPORT_PENDING,
    SET_PUMPREPORT,
    SET_CURRENT_FIELD,
    SET_SI_VALUE_PENDING,
    SET_SIVALUE,
    SET_UNIT_VALUE_PENDING,
    SET_UNIT_VALUE_CHANGE,
    SET_UNIT_CONVERTOR_PENDING,
    SET_UNIT_CONVERTOR_DATA,
    SET_UNIT_CURRENTFIELD,
    SET_UNIT_CONVERSION_RESPONSE,
    SET_UPDATE_RPM_PENDING,
    SET_UPDATE_RPM_VALUE,
    SET_IS_HYDROLUBRIC,
} from "../constants/pumpSelection.constants";
import { pumpDataState } from "../../types/pumpData";

const initialState: pumpDataState = {
    selectedUnit: 'metric',
    getFamilyPending: false,
    isGetSearchDataPending: false,
    pager: {},
    isPrintSelectionOpen: false,
    isQeffPending: false,
    isShaftPending: false,
    pumpFamily: "",
    filterValues: {},
    selectionCriteria: null,
    getReportPending: false,
    currentField: "",
    SIvalue: {unitLabel: "", value: 0},
    unitConversionPending: false,
    unitConversionData: "",
    unitCurrentField: "",
    unitFilter: {
      flow: [],
      density: [],
      pressure: [],
      length: [],
      mass: [],
      area: [],
      temperature: [],
      viscosity: [],
      power: [],
      volume: [],
    },
    UpdateRPMPending: false,
    isHydroLubric: true,
};

export default (
    localState: UserState = initialState,
    action: Action
  ): pumpDataState => {
    switch (action.type) {
      case SET_UNIT_VALUE_SELECTION: {
        return {
          ...localState,
          selectedUnit: action.payload,
        };
      }
      case SET_PUMP_FAMILIES_PENDING: {
        return {
          ...localState,
          getFamilyPending: true,
        };
      }
      case SET_PUMP_FAMILIES: {
        return {
          ...localState,
          familyList: action.payload,
        };
      }
      case GET_SEARCHDATA_PENDING: {
        return {
          ...localState,
          isGetSearchDataPending: true,
        };
      }
      case SET_SEARCHDATA: {
        const  data  = action.payload;
        return {
          ...localState,
          isPending: false,
          searchResult: data && data.value,
          totalRecords: data && data["@odata.count"],
          isGetSearchDataPending: false,
        };
      }
      case GET_SEARCHDATA_SUCCESS: {
        return {
          ...localState,
          isGetSearchDataPending: false,
        };
      }
      case GET_SEARCHDATA_ERROR: {
        return {
          ...localState,
          searchDataError: action.payload,
        };
      }
      case SET_PUMP_DATA_LIST_PAGER: {
        return {
          ...localState,
          pager: {
            ...action.payload,
          },
        };
      }
      case OPEN_PRINT_SELECTION_MODEL: {
        return {
          ...localState,
          isPrintSelectionOpen: true,
        };
      }
      case CLOSE_PRINT_SELECTION_MODEL:{
        return {
          ...localState,
          isPrintSelectionOpen: false,
        }
      }
      case SET_QEFF_GRAPH_PENDING: {
        return {
          ...localState,
          isQeffPending: true,
        }
      }
      case SET_QEFF_GRAPH: {
        return {
          ...localState,
          QeffGraphData: action.payload,
          isQeffPending: false,
        }
      }
      case SET_SHAFT_GRAPH_PENDING: {
        return {
          ...localState,
          isShaftPending: true,
        }
      }
      case SET_FILTER_VALUES: {
        return {
          ...localState,
          filterValues: action.payload,
        }
      }
      case SET_PUMP_FAMILY: {
        return {
          ...localState,
          pumpFamily: action.payload,
        }
      }
      case SET_SHAFT_GRAPH: {
        return {
          ...localState,
          shaftGraphData: action.payload,
        }
      }
      case SET_SELECTION_CRITERIA: {
        return {
          ...localState,
          selectionCriteria: action.payload,
        }
      }
      case SET_PUMPREPORT_PENDING: {
        return {
          ...localState,
          getReportPending: true,
        }
      }
      case SET_PUMPREPORT: {
        return {
          ...localState,
          pumpReport: action.payload,
        }
      }
      case SET_CURRENT_FIELD: {
        return {
          ...localState,
          currentField: action.payload,
        }
      }
      case SET_SI_VALUE_PENDING: {
        return {
          ...localState,
          setSIPending: true,
        }
      }
      case SET_SIVALUE: {
        return {
          ...localState,
          SIvalue: action.payload,
          setSIPending: false,
        }
      }
      case SET_UNIT_VALUE_PENDING: {
        return {
          ...localState,
          unitChangePending: true,
        }
      }
      case SET_UNIT_VALUE_CHANGE:{
        return {
          ...localState,
          unitResponse: action.payload,
        }
      }
      case SET_UNIT_CONVERTOR_PENDING: {
        return {
          ...localState,
          unitConversionPending: true,
        }
      }
      case SET_UNIT_CONVERTOR_DATA: {
        return {
          ...localState,
          unitConversionData: action.payload,
          unitConversionPending: false,
        }
      }
      case SET_UNIT_CURRENTFIELD:{
        return {
          ...localState,
          unitCurrentField: action.payload,
        }
      }
      case SET_UNIT_CONVERSION_RESPONSE: {
        const data = action.payload;
        return {
          ...localState,
          unitFilter:{
            // ...initialState.unitFilter,
           ...data,
          }
        
      }
      }
      case SET_UPDATE_RPM_PENDING: {
        return{
          ...localState,
          UpdateRPMPending: true,
        }
      }
      case SET_UPDATE_RPM_VALUE: {
        return{
          ...localState,
          QeffGraphData: action.payload,
          UpdateRPMPending: false,
        }
      }
      case SET_IS_HYDROLUBRIC: {
        return {
          ...localState,
          isHydroLubric: action.payload,
        }
      }
      default: {
        return localState;
      }
    }
      };